import 'babel-polyfill';
import React, { Component } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { calculateResponsiveState } from 'redux-responsive';
import debounce from 'lodash/debounce';

// import scss: necessary for webpack to include it
import './scss/main.scss';
import makeStore from './store';
import { preloadedState } from './common/api';
import AppConnected from './containers/AppConnected';

// could pass makeStore a pre-loaded / hydrated state here instead of an empty object
const store = makeStore(preloadedState());

// fire redux-responsive on window resize event
window.addEventListener('resize', debounce(() =>
  store.dispatch(calculateResponsiveState(window)), 150));

render(
  <Provider store={store}>
    <AppConnected />
  </Provider>,
  document.getElementById('bay-water-trail-map')
);



// WEBPACK FOOTER //
// ./map/index.js